import {
  ESC_PROFILE_KEY,
  isLoggedIntoSubscriptionCenter,
  logOffSubscriptionCenter,
} from '../../../global/authentication/authentication-manager.js'
import { getRelativeBasePath } from '../../../global/environments/path.js'

const key = localStorage.getItem(ESC_PROFILE_KEY) || null
const profile = JSON.parse(key) || null

const escLogoutButton = document.querySelector('.Esc-logout')

if (
  isLoggedIntoSubscriptionCenter() &&
  profile &&
  profile.wholeSalerID !== null
) {
  escLogoutButton.classList.remove('u-hidden')
}

escLogoutButton.addEventListener('click', () => {
  logOffSubscriptionCenter()

  window.location.href =
    getRelativeBasePath() + '/subscribe/sign-in?logout=true'
})
